import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import Switches from 'vue-switches';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader } from 'vue-loaders';
import vSelect from 'vue-select'

Vue.use(BootstrapVue)


var BE_URL = `https://be.bbocal.mejty.cz/`

new Vue({
    el: '#app',
    components: {
        Switches,
        'v-select': vSelect,
        BallPulseLoader,
    },
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js